import React from "react";
import "./UniqueSellingProposition.css";
import megaphoneWoman from "../../assets/megaphone-woman.png";

const UniqueSellingProposition = () => {
  return (
    <section className="usp-section">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-6">
            <div className="usp-header">
              <h2>
                UNIQUE <span>SELLING</span>
              </h2>
              <h3>PROPOSITION</h3>
              <div className="usp-usb-p">
                <p className="usp-usb">USP</p>
                <p style={{ 
                    backgroundColor: 'rgba(236, 236, 236, 0.23)', 
                    padding: '5px', 
                    width: '200px', 
                    height: '20px',
                    }}>
                    </p>
              </div>
            </div>

            <div className="usp-content">
              <div className="usp-quote">
                
                {/* <span className="quote-icon starts">“</span> */}
                <span className="quote-icon start">“</span>
                <p>
                  Unlike traditional software firms, <strong>Syrol</strong> combines
                  deep domain expertise in fintech, banking, and enterprise
                  transformation with a security-first development approach ensuring
                  not just functionality but resilience followed by availability and
                  great user experience.
                </p>
                <span className="quote-icon end">”</span>
              </div>
            </div>
          </div>
          
          <div className="col-lg-6 d-none d-md-block">
            <div className="usp-image">
              <img 
                src={megaphoneWoman} 
                alt="Woman with megaphone" 
                className="img-fluid"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default UniqueSellingProposition;
